import { render, staticRenderFns } from "./T3d-model-documents.component.vue?vue&type=template&id=1a1d6714"
import script from "./T3d-model-documents.component.ts?vue&type=script&lang=ts&external"
export * from "./T3d-model-documents.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports